// extracted by mini-css-extract-plugin
export default {"jobsContainer":"Industry-Jobs_jobsContainer__wu147","button":"Industry-Jobs_button__bFEYx"};